export default {
  // 获取投票详细接口
  ballotDetailed: '/amc/client/ballotDetailed',
  // 提交投票
  addBallotData: '/amc/client/addBallotData'
}